// extracted by mini-css-extract-plugin
export default {"ArrowButton":"ArrowButton_ArrowButton__IMhG7","fillAnimation_white":"ArrowButton_fillAnimation_white__ccKoi","spin":"ArrowButton_spin__Jj8DL"};